import React from 'react';
import { useField } from 'formik';
import { GiactContainer } from '../../GIACT/GiactContainer';
import type { IACHDisbursementFormData } from '../../../../../../../types/order/escrow/achDisbursements/IACHDisbursementFormData';
import { useGetACHRoutingNumberQuery } from '../../../../../../../API/order/escrow/AchDisbursementAPI';

export const GiactField: React.FC<{ isReadOnly: boolean; isDirty: boolean }> = ({ isReadOnly, isDirty }) => {
  const [{ value: data }] = useField<IACHDisbursementFormData>('value');

  const { data: bank } = useGetACHRoutingNumberQuery(data.account?.routingNumber ?? '', {
    skip: data.account?.routingNumber?.length !== 9,
  });

  if (isDirty || isReadOnly) {
    return null;
  }

  return (
    <GiactContainer
      accountId={data.account?.id}
      routingNumber={data.account?.routingNumber ?? ''}
      accountNumber={data.account?.accountNumber}
      beneficiaryName={data.account?.name}
      routingBankName={bank?.bankName}
      disbursementType={data.type}
      disbursementId={data.id}
      isReadOnly={isReadOnly}
      giact={data.giact}
    />
  );
};
